<template>
    <v-skeleton-loader
            height="110"
            width="100%"
            type="list-item-avatar-three-line"
            transition="fade-transition"
    ></v-skeleton-loader>
</template>

<script>
    export default {
        name: "ProfileMenuSkeleton"
    }
</script>

<style scoped>

</style>
